import { NgModule } from '@angular/core';

import { NvD3Component } from './nvd3.component';

/**
 * Ivy-native replacement for `ng2-nvd3`'s `NvD3Module`. Kept API-identical
 * (same module name, declares/exports `NvD3Component`) so the existing chart
 * modules only need to change their import path from `'ng2-nvd3'` to this file.
 * See ANGULAR16_MIGRATION_PLAN.md (blocker P2).
 */
@NgModule({
    declarations: [NvD3Component],
    exports: [NvD3Component],
})
export class NvD3Module {}
